import Button from "@/components/Button";
import useGTM from "@/hooks/useGTM";
import posthog from "posthog-js";

const SignUpCTAButton = ({
  componentLocation = "recipe_hero",
  buttonLabel = "Start Your Free Trial",
  eventName = "recipe_hero_signup_cta_clicked",
}: {
  componentLocation?: string;
  buttonLabel?: string;
  eventName?: string;
}) => {
  const gtm = useGTM();

  const handleClick = () => {
    // PostHog Event
    posthog.capture(eventName, {
      componentLocation,
      buttonLabel,
    });

    // GTM Event
    gtm.pushEvent(eventName, {
      componentLocation,
      buttonLabel,
    });

    return null;
  };

  return (
    <Button
      theme="violet"
      href="/onboarding"
      className="max-xs:h-component-sm lg:h-component-lg w-fit px-6 max-xs:px-4 max-xs:text-xs lg:px-8"
      label={buttonLabel}
      onClick={handleClick}
    />
  );
};

export default SignUpCTAButton;
